import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 27 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25.5 0h-24C1.102 0 .72.161.44.448.157.734 0 1.123 0 1.528v3.958c0 .799.32 1.584.875 2.15L9 15.913v11.592c0 .26.066.516.19.743.125.228.304.419.522.556a1.482 1.482 0 0 0 1.459.068l6-3.056c.508-.26.829-.788.829-1.367v-8.536l8.125-8.277A3.097 3.097 0 0 0 27 5.486V1.528c0-.405-.158-.794-.44-1.08A1.486 1.486 0 0 0 25.5 0ZM15.44 14.2a1.524 1.524 0 0 0-.44 1.08v8.224l-3 1.528V15.28a1.547 1.547 0 0 0-.44-1.08L3 5.486v-2.43h21.002l.003 2.419L15.44 14.2Z",
      fill: "#394053"
    }, null, -1)
  ]))]))
}
export default { render: render }